export const FORMATO_FECHA = {
    YYYY_MM_DD_HH_MM_SS: "YYYY/MM/DD HH:mm:ss",
};